import { Command, Option } from "clipanion";
import { M8tCommand } from "../lib/m8t-command.js";
import { CLI_VERSION } from "../lib/package-version.js";
import { renderJson, renderKeyValueBlock, resolveOutputMode } from "../lib/output.js";

export class VersionCommand extends M8tCommand {
  static paths = [["version"], ["--version"], ["-v"]];

  static usage = Command.Usage({
    description: "Print the CLI version.",
    details:
      "Prints the m8t CLI version. With --verbose, also prints Node version and platform.",
    examples: [
      ["Print the CLI version", "$0 version"],
      ["Print as JSON", "$0 version --output json"],
    ],
  });

  output = Option.String("--output", { description: "pretty | json | auto (default)" });
  verbose = Option.Boolean("--verbose", false);

  executeCommand(): Promise<number> {
    const mode = resolveOutputMode(
      (this.output as "pretty" | "json" | "auto" | undefined) ?? "auto",
      this.context.stdout as NodeJS.WriteStream,
    );

    if (mode === "json") {
      const payload: Record<string, string> = { version: CLI_VERSION };
      if (this.verbose) {
        payload.node = process.version;
        payload.platform = `${process.platform}/${process.arch}`;
      }
      this.context.stdout.write(renderJson(payload) + "\n");
      return Promise.resolve(0);
    }

    if (!this.verbose) {
      this.context.stdout.write(`${CLI_VERSION}\n`);
      return Promise.resolve(0);
    }

    const block = renderKeyValueBlock([
      { key: "m8t", value: CLI_VERSION },
      { key: "node", value: process.version },
      { key: "platform", value: `${process.platform}/${process.arch}` },
    ]);
    this.context.stdout.write(block + "\n");
    return Promise.resolve(0);
  }
}
